import React from 'react';
import TowerEquipmentTypeListPageContainer from './TowerEquipmentTypeListPageContainer';

export class TowerEquipmentTypeListPage extends React.Component{
    
    render(){
      return (
        <TowerEquipmentTypeListPageContainer {...this.props}/>
      )
    }
}

